import React from "react";
import { mergeKpiConfigs } from "../config";
import InfoTitle from "./InfoTitle";
import { valueFormator } from "./valueFormator";

const KpiValue = ({ value, valueConfig, option }) => {
  ({ valueConfig } = mergeKpiConfigs(option, {
    valueConfig,
  }));
  return (
    <div>
      <InfoTitle
        title={valueFormator(value, valueConfig.system, {
          format: valueConfig.format,
          decimals: valueConfig.decimals,
        })}
        {...valueConfig}
      />
    </div>
  );
};

export default KpiValue;
